// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"emailRecipientInput_wrapper__1H02m"};